import { createActions } from 'redux-actions';

export const PREFIX = '@@nosturi/app';

export default createActions(
  {
    RESET: [(key, value) => value, (key, value) => ({ key })],
    //ACK: [(uuid, state) => state, (uuid, state) => ({ ack: uuid })],
    CONNECT: [undefined, () => ({ local: true })],
    DISCONNECT: [undefined, () => ({ local: true })],
    CONNECTED: undefined,
    DISCONNECTED: undefined,
    SET_IDENTITY: undefined,
  },
  {
    prefix: PREFIX,
  },
);



// WEBPACK FOOTER //
// ./src/actions.js